import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { POPULAR_AREAS } from 'dpl/shared/constants/shelters';
import LocationResult from 'dpl/search_result_filters/components/UserLocation/LocationResult';
import SearchNoResults from 'dpl/components/Search/SearchNoResults';

/** @param {any} props */
export default function MobileLocationResultsList({
  googlePlacesResults,
  query = null,
  onSelectItem
}) {
  const timeoutRef = useRef(null);
  const [clickedItemKey, setClickedItemKey] = useState(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  function getProps({ itemKey }) {
    return {
      classes: {
        icon: 'pv3 ph3',
        wrapper: `font-16 gap-16 transition-bg ph5 pv2${
          clickedItemKey === itemKey ? ' bg-subtle-gray' : ''
        }`
      },
      iconSize: '24px',
      onClick: place => {
        setClickedItemKey(itemKey);

        timeoutRef.current = setTimeout(() => {
          setClickedItemKey(null);
          onSelectItem(place);
        }, 300);
      }
    };
  }

  return (
    <div className="MobileLocationSearchResultsList">
      {(() => {
        if (!query) {
          return POPULAR_AREAS.map((area, idx) => (
            <LocationResult
              key={area.url}
              place={area}
              {...getProps({ itemKey: `popular-${idx}` })}
            />
          ));
        }

        return googlePlacesResults.length === 0 ? (
          <SearchNoResults className="ph5 pv2" query={query} />
        ) : (
          googlePlacesResults.map((place, idx) => (
            <LocationResult
              key={idx}
              place={place}
              {...getProps({ itemKey: `results-${idx}` })}
            />
          ))
        );
      })()}
    </div>
  );
}

MobileLocationResultsList.propTypes = {
  query: PropTypes.string,
  googlePlacesResults: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      getCoordinates: PropTypes.func.isRequired
    })
  ).isRequired,
  onSelectItem: PropTypes.func.isRequired
};
